/* eslint-disable import-x/order */
import './global'
import 'virtual:uno.css'
import '@policyfly/components/styles.css'

import { createApp } from 'vue'

import { pinia } from './plugins/pinia'
import { vuetify } from './plugins/vuetify'
import { installDevtools } from './plugins/devtools/plugin'
import { installSentry } from './plugins/sentry'
import { i18n } from './plugins/i18n'

import App from './App.vue'
import router from './router'
import './api/interceptors'
import {
  authenticationGuard,
  capabilityGuard,
  programQueryGuard,
  programSettingsGuard,
} from './router/middleware'

router.beforeEach(authenticationGuard)
router.beforeEach(programQueryGuard)
router.beforeEach(programSettingsGuard)
router.beforeEach(capabilityGuard)

const app = createApp(App)

if (import.meta.env.VITE_SENTRY === 'true') {
  installSentry(app)
}

app.use(router)
app.use(pinia)
app.use(vuetify)
app.use(i18n)

if (import.meta.env.VITE_DEVTOOLS === 'true') {
  installDevtools(app)
} else {
  app.mount('#app')
}
